var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "calendar_18dp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0103\\u66F4\\u65B0-\\u589E\\u52A0hosts\\u5217\\u8868\\u9875\\u9762",
    transform: "translate(-265.000000, -497.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-9\\u5907\\u4EFD-6",
    transform: "translate(42.000000, 280.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-25",
    transform: "translate(16.000000, 217.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar_18dp",
    transform: "translate(207.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25,3 L13.5,3 L13.5,1.5 L12,1.5 L12,3 L6,3 L6,1.5 L4.5,1.5 L4.5,3 L3.75,3 C2.9175,3 2.2575,3.675 2.2575,4.5 L2.25,15 C2.25,15.825 2.9175,16.5 3.75,16.5 L14.25,16.5 C15.075,16.5 15.75,15.825 15.75,15 L15.75,4.5 C15.75,3.675 15.075,3 14.25,3 Z M14.25,15 L3.75,15 L3.75,7.5 L14.25,7.5 L14.25,15 Z M6.75,10.5 L5.25,10.5 L5.25,9 L6.75,9 L6.75,10.5 Z M9.75,10.5 L8.25,10.5 L8.25,9 L9.75,9 L9.75,10.5 Z M12.75,10.5 L11.25,10.5 L11.25,9 L12.75,9 L12.75,10.5 Z M6.75,13.5 L5.25,13.5 L5.25,12 L6.75,12 L6.75,13.5 Z M9.75,13.5 L8.25,13.5 L8.25,12 L9.75,12 L9.75,13.5 Z M12.75,13.5 L11.25,13.5 L11.25,12 L12.75,12 L12.75,13.5 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a6009884b4eedd275e38026c7df344f6.svg";
export { ForwardRef as ReactComponent };